import { render, staticRenderFns } from "./AocDuplicate.vue?vue&type=template&id=6a40c75b&"
import script from "./AocDuplicate.vue?vue&type=script&lang=js&"
export * from "./AocDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports